import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
export interface FinanceEntry {id:string;kind:string;occurredAt:string;amountRub:number;feeRub:number;taxRub:number;creditedUsd:number;feeUsd:number;rubPerUsd:number|null;reference:string;note:string;channel:string;userId:string|null;email:string|null;subscriptionId:string|null;relatedEntryId:string|null;purchaseId:string|null;paymentOrderId?:string|null;providerRefundId?:string|null;refundReviewRequired?:boolean;taxMonth:string|null;feeEstimated:boolean;voidedAt:string|null;voidReason:string|null}
export interface FinanceData {
 settings:{rubPerUsd:number;processorPercent:number;taxPercent:number;routerFeeUsd:number};
 totals:{partnerAccruedRub:number;partnerPaidRub:number;grossRub:number;refundsRub:number;processorRub:number;taxRub:number;taxPaidRub:number;routerDepositsRub:number;routerDepositsUsd:number;overheadRub:number;aiUsd:number;aiRub:number;profitRub:number;cashFlowRub:number;fxEstimateCalls:number;unknownCostCalls:number;estimatedFeeEntries:number};
 partnerOutstandingRub:number;allTimeAiUsd:number;allTimeAiRub:number;taxOutstandingRub:number;unconfirmedSubscriptions:number;
 taxMonths:Array<{month:string;receiptsRub:number;taxRub:number;paidRub:number}>;
 entries:FinanceEntry[];
 users:Array<{id:string;email:string;aiRub:number;aiUsd:number;calls:number;messages:number;netReceiptsRub:number}>;
}
export const financeKinds:Record<string,string>={customer_payment:"Оплата пользователя",customer_refund:"Возврат пользователю",openrouter_topup:"Пополнение OpenRouter",operating_expense:"Расход сервиса",tax_payment:"Уплата налога"};
export function financePeriodParams(from?: string, to?: string) {
 const params = new URLSearchParams();
 // The API accepts dates from the Unix epoch. The local 1970-01-01 boundary
 // otherwise becomes 1969-12-31 in UTC and invalidates the entire report.
 if (from) params.set("from", new Date(Math.max(0, new Date(from + "T00:00:00+07:00").getTime())).toISOString());
 if (to) params.set("to", new Date(new Date(to + "T00:00:00+07:00").getTime() + 86400000).toISOString());
 return params;
}
export function useFinance(from?: string, to?: string) {
 return useQuery({
  queryKey: ["admin-finance", from, to],
  refetchInterval: 30000,
  queryFn: async () => {
   const r = await api.get<FinanceData>("/v1/admin/finance?" + financePeriodParams(from, to));
   if (!r.ok) throw new Error(r.error);
   return r.data;
  },
 });
}

export const dayNow=()=>new Intl.DateTimeFormat("sv-SE",{timeZone:"Asia/Barnaul"}).format(new Date());
export const csvCell=(value:unknown)=>'"'+String(value??"").replace(/^[=+@-]/," '$&").replaceAll('"','""')+'"';

export const fmtMoney=(n:number)=>new Intl.NumberFormat("ru-RU",{style:"currency",currency:"RUB",minimumFractionDigits:2,maximumFractionDigits:2}).format(n);
